import { Injectable, inject } from '@angular/core';

import { RouterSelectors } from '@next/core-lib/router-store';
import { SiteState } from '@next/core-lib/site';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { switchMap, take, withLatestFrom } from 'rxjs/operators';

import { getAllCustomers } from '../store/customer.selectors';

@Injectable({
  providedIn: 'root',
})
export class CustomersGuard {
  private readonly store = inject<Store<SiteState>>(Store);

  getCustomers() {
    return this.store.pipe(
      select(RouterSelectors.getMergedRoute),
      withLatestFrom(this.store.select(getAllCustomers)),
      take(1),
    );
  }

  canActivate(): Observable<boolean> {
    return this.getCustomers().pipe(
      switchMap(() => [true]),
      take(1),
    );
  }
}
